

import React from "react";
import HlcContactSection from "./HlcContactSection";
import HlcSiteFooter from "./HlcSiteFooter";

const HlcFooter = () => {
  return (
    <>
      {/* ── CONTACT / CONSULTATION SECTION (see HlcContactSection.js) ── */}
      <HlcContactSection />

      {/* ── PREMIUM SITE FOOTER (see HlcSiteFooter.js) ── */}
      <HlcSiteFooter />
    </>
  );
};

export default HlcFooter;